// EXTERNAL
import React from "react";
// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// CONTEXT
import { useCreativeDispatch, useCreativeState } from "../../../../contexts/creative.context";
// CONFIGS
import studio_config from "../../../../configs/studio.json";
// TYPES
import { StudioConfig } from "../types";

interface FrameRatioBarProps {
  adSize: string;
}

export function FrameRatioBar({ adSize }: FrameRatioBarProps) {
  const creative = useCreativeState();
  const creativeDispatch = useCreativeDispatch();
  const studioConfig: StudioConfig = studio_config;

  /**
   * JA (18-08-23)
   * Gets a list of all frame ratio objects that have a truthy active value.
   * Filter that list so only frame ratio objects with an adSize matching the adSize selected is kept.
   * Fallback to the post format as the accessed format key if user is making a new creative.
   */
  const frameRatios: FrameRatio[] = studioConfig.formats[creative.metadata.format || "post"].media.frameRatios.filter((frameRatio: FrameRatio) => frameRatio.active);
  const formatRatios = frameRatios.filter((frameRatio) => frameRatio.adSize === adSize);

  const handleClick = (e: React.MouseEvent<Element, MouseEvent> | undefined, frameRatio: FrameRatio, index: number) => {
    (e?.currentTarget as HTMLElement).blur();

    creativeDispatch({
      type: "UPDATE_CREATIVE_METADATA_ASPECTRATIO",
      payload: { aspectRatio: frameRatio.name },
    });
  };

  return (
    <>
      <p className="text-size-4 color-text-5 platform-font ma0 fw5">{"Frame Ratio"}</p>
      <ComponentLibrary.PCSpacer type="margin" position="top" size={4} />
      <div className="border-color-neutral-3 ba padding-around-1 border-radius-4 flex flex-wrap" style={{ justifyContent: "space-evenly" }}>
        {formatRatios.map((frame: FrameRatio, index: number) => (
          <div key={index}>
            <ComponentLibrary.PCActionButton clickHandler={(e) => handleClick(e, frame, index)} text={frame.ratio} textColor={creative.metadata.aspectRatio === frame.name ? "color-primary-3" : "color-text-2"} color={creative.metadata.aspectRatio === frame.name ? "background-color-neutral-2" : "background-color-neutral-1"} />
          </div>
        ))}
      </div>
    </>
  );
}
